// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(min-width: 1024px)";
var _5 = "equipment_baggage-2ngSO";
var _6 = "overweight_baggage-3nMHo";
var _7 = "extra_baggage-123Ib";
var _8 = "included_baggage-X1klX";
var _9 = "baggage-1iOra";
var _a = "fullscreenModal__content-WrkxT";
var _b = "head-2QAtX baggage__head";
var _c = "head__wrapper-OH2xn";
var _d = "header-3d2xP";
var _e = "subheader-29DYx";
var _f = "infoMessage__htmlMessage-3ydXF";
var _10 = "infoMessage__htmlMessageContent-2whxx";
var _11 = "items-tgvM2";
var _12 = "newBaggage-2n32u";
var _13 = "additional-3fNOy";
var _14 = "additionalBaggage-nZQog";
var _15 = "passenger-12Vjq";
var _16 = "passenger_active-2gzFQ";
var _17 = "rules-1cPaw";
var _18 = "baggage__passenger-2waJ0";
var _19 = "baggage__passenger__value-3UltW";
var _1a = "baggage__passenger__icon-3QPuu";
var _1b = "baggage__passenger_active-3fKaY";
var _1c = "infoMessage-kJRGP";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "desktop_only", _5 as "equipment_baggage", _6 as "overweight_baggage", _7 as "extra_baggage", _8 as "included_baggage", _9 as "baggage", _a as "fullscreenModal__content", _b as "head", _c as "head__wrapper", _d as "header", _e as "subheader", _f as "infoMessage__htmlMessage", _10 as "infoMessage__htmlMessageContent", _11 as "items", _12 as "newBaggage", _13 as "additional", _14 as "additionalBaggage", _15 as "passenger", _16 as "passenger_active", _17 as "rules", _18 as "baggage__passenger", _19 as "baggage__passenger__value", _1a as "baggage__passenger__icon", _1b as "baggage__passenger_active", _1c as "infoMessage" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "desktop_only": _4, "equipment_baggage": _5, "overweight_baggage": _6, "extra_baggage": _7, "included_baggage": _8, "baggage": _9, "fullscreenModal__content": _a, "head": _b, "head__wrapper": _c, "header": _d, "subheader": _e, "infoMessage__htmlMessage": _f, "infoMessage__htmlMessageContent": _10, "items": _11, "newBaggage": _12, "additional": _13, "additionalBaggage": _14, "passenger": _15, "passenger_active": _16, "rules": _17, "baggage__passenger": _18, "baggage__passenger__value": _19, "baggage__passenger__icon": _1a, "baggage__passenger_active": _1b, "infoMessage": _1c }
